import React, { useEffect, useState } from "react";
// import DoubleArrowIcon from "@/icons/withdraw/doubleArrowIcon";
import { Input } from "@/components/ui/popInput";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { Button } from "@/components/ui/button";
// import SharkCoinIcon from "@/icons/other/sharkIcon";
import { currenciesByNetwork, networkData } from "./CardPaymentData";
import { useStartTransaction } from "@/services/payment.service";

const CardPayment: React.FC = () => {
  const startPayment = useStartTransaction();
  const [selectedNetworkValue, setSelectedNetworkValue] = useState(
    networkData[0].value,
  );
  const [currencyData, setCurrencyData] = useState(
    currenciesByNetwork[selectedNetworkValue],
  );
  const [selectedCurrencyValue, setSelectedCurrencyValue] = useState(
    currencyData[0].value,
  );

  const [amount, setAmount] = useState("0");

  useEffect(() => {
    // Update currency options when the network changes
    setCurrencyData(currenciesByNetwork[selectedNetworkValue]);
    setSelectedCurrencyValue(
      currenciesByNetwork[selectedNetworkValue][0].value,
    );
  }, [selectedNetworkValue]);

  return (
    <div className="mt-2">
      <div className="flex max-sm:justify-between">
        {/* Currency Dropdown */}
        <div className="mr-2 w-full max-md:mr-3">
          <span className="text-sm font-medium text-white/50">Currency</span>
          <div className="mt-1 w-full rounded-md border-1 border-solid border-white/5">
            <Select
              value={selectedCurrencyValue}
              onValueChange={setSelectedCurrencyValue}
            >
              <SelectTrigger className="w-full border-2 border-white/5 bg-white/5 text-white">
                <SelectValue />
              </SelectTrigger>
              <SelectContent className="border-2 border-white/5 bg-[#00154A]">
                {currencyData.map((item) => (
                  <SelectItem
                    key={item.value}
                    value={item.value}
                    className="mb-1 bg-white/5"
                  >
                    <div className="flex w-full items-center justify-between gap-2">
                      <div className="flex items-center">
                        <div>{item.Icon && <item.Icon size={18} />}</div>
                        <div className="ml-2 max-w-20 truncate text-xs text-white/40">
                          {item.label}
                        </div>
                      </div>
                      <div className="flex text-white">{item.currencyType}</div>
                    </div>
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>
        </div>

        {/* Network Dropdown */}
        <div className="w-full">
          <span className="text-sm font-medium text-white/50">Network</span>
          <div className="mt-1 w-full rounded-md border-1 border-solid border-white/0">
            <Select
              value={selectedNetworkValue}
              onValueChange={setSelectedNetworkValue}
            >
              <SelectTrigger className="w-full border-2 border-white/5 bg-white/5 text-white">
                <SelectValue />
              </SelectTrigger>
              <SelectContent className="border-2 border-white/5 bg-[#00154A]">
                {networkData.map((item) => (
                  <SelectItem
                    key={item.value}
                    value={item.value}
                    className="mb-1 bg-white/5"
                  >
                    <div className="flex items-center justify-between text-end">
                      <div>{item.Icon && <item.Icon />}</div>
                      <div className="ml-2 text-white">{item.label}</div>
                    </div>
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>
        </div>
      </div>

      <div className="mt-3 w-full">
        <div className="flex justify-between">
          <label
            htmlFor="amount"
            className="mb-1 block text-sm font-medium text-white/50"
          >
            Amount
          </label>
          {/* <div className="flex gap-2">
            <span className="text-sm text-white/50">Balance</span>
            <SharkCoinIcon size={18} />
            <span className="text-sm">6758</span>
          </div> */}
        </div>
        <div className="flex w-full items-center gap-2">
          <div className="flex w-full items-center justify-between rounded-md border-2 border-solid border-white/10 bg-white/5 pl-1 text-white">
            {/* <div>
              <SharkCoinIcon size={16} />
            </div> */}
            <Input
              type="text"
              placeholder="0.00"
              value={amount}
              onChange={(e) => {
                setAmount(e.target.value);
              }}
              className="w-full border-none bg-transparent text-white selection:bg-none"
            />
            <span className="pr-2 text-white/80">{selectedCurrencyValue}</span>
          </div>
          {/* <div className="border-1 flex w-10 items-center rounded-md border-2 border-solid border-white/10 bg-white/5 p-2">
            <DoubleArrowIcon size={20} />
          </div>
          <div className="w-full">
            <Input
              type="text"
              placeholder="$0.00"
              className="w-full rounded-md border-2 border-solid border-white/10 bg-white/5 text-white"
            />
          </div> */}
        </div>
      </div>

      <div className="mb-3 mt-3 w-full">
        <label
          htmlFor="promo"
          className="mb-1 block text-sm font-medium text-white/50"
        >
          Promo code
        </label>
        <Input
          id="Promo"
          type="text"
          placeholder="2ld68hjd"
          disabled
          className="mt-1 w-full rounded-md border-2 border-solid border-white/10 bg-white/5 px-3 py-2 text-white"
        />
      </div>

      {/* <div className="my-3 flex">
        <p className="text-xs text-gray-300 text-white/50">
          Minimum withdrawal is $10 . Transaction fee is $0.00
        </p>
      </div> */}
      <Button
        className="mt-3 flex w-full rounded-md bg-gradient-to-r from-[#003BD2] to-[#00FFC2]"
        onClick={() => {
          startPayment.mutate(
            { amount: parseFloat(amount) * 100 },
            {
              onSuccess: ({ data }) => {
                const paymentLink = JSON.parse(data.meta).details.approval_url;
                window.location.href = paymentLink;
              },
              onError: (err) => {
                console.error("Error updating user:", err);
              },
            },
          );
        }}
      >
        Deposit
      </Button>
    </div>
  );
};

export default CardPayment;
